import { useQuery } from '@tanstack/react-query';

/**
 * Fetch recipes with pagination and search
 * @returns {object}
 */
function useCategories({ id = null }) {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['categories'],
		queryFn: async () => {
			const response = await fetch(
				'https://us-central1-euneos-cms-prod.cloudfunctions.net/api/categories'
			);

			// API returns all categories
			// If is null, return all categories
			if (id === null) {
				return await response.json();
			}

			// If is not null, return category related to id
			const categories = await response.json();
			return categories.filter((cat) => cat.uid === id);
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useCategories };
